import { CommonResponse } from '@gtpl/shared-models/masters';
import { ConsumedQtyRequest, GetAllConsumptionItemsResponseModel, getAllStoreConsumptionsResponse, GetStoreConsumptionResponse, GetStoreConsumptionSosResponseModel, getStoreConsumptionsResponse, IssuesDropDownResponse, PlaceListPalletDto, SaleOrderIdRequest, saleOrderNoRequest, StoreConsumptionDetails, StoreConsumptionReportResponse, StoreConsumptionResponse, UpdatePlaceListStatus } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';
import { ItemCodeRequest } from '../stock/dto/item-code.request.dto';
import { StockItemRequest } from '../stock/dto/stock-item.request';
import { UnitRequest } from '../stock/dto/unit.id.request';
import { EtdWiseDto } from './dto/etd-wise.dto';
import { ConsumedItemsForSoReq } from './dto/get-consumed-items.dto';
import { ConsumtionReportRequest } from './dto/get-consumtion-report.request';
import { GetStoreConsumptionRequest } from './dto/get-store-consumption.request';
import { IndentFormDto } from '../indent/dto/indent-form.dto';
import { PlaceListDto } from './dto/place-list.dto';
import { StoreConsumptionData } from './dto/store-consumption.dto';
import { StoreIssuesRequest } from './dto/store-issues-dto';
import { UnitIdRequest } from './dto/unit-id.request';
import { StoreConsumptionService } from './store-consumption.service';

@ApiBearerAuth()
@ApiTags('storeConsumption')
@Controller('store-consumption')
export class StoreConsumptionController {
    constructor(private storeConsumptionService: StoreConsumptionService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    /**
     * to Create Store Consumption Data
     * @param storeConData 
     * @returns 
     */
    @Post('createStoreConsumedStock')
    async createStoreConsumedStock(@Body() storeConData: StoreConsumptionData): Promise<StoreConsumptionResponse> {
        console.log(storeConData);
        try {
            return this.storeConsumptionService.createStoreConsumedStock(storeConData);
        } catch (error) {
            console.log(storeConData);

            return this.applicationExceptionHandler.returnException(StoreConsumptionResponse, error);
        }
    }

    /**
     * to Create Store Consumption Data
     * @param storeConData 
     * @returns 
     */
    @Post('updateStoreConsumedStock')
    async updateStoreConsumedStock(@Body() storeConData: StoreConsumptionData): Promise<StoreConsumptionResponse> {
        try {
            return this.storeConsumptionService.createStoreConsumedStock(storeConData, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(StoreConsumptionResponse, error);
        }
    }

    /**
     * get All Store Consumptions Data
     * @param storeConData 
     * @returns 
     */
    @Post('getAllStoreConsumptionsData')
    async getAllStoreConsumptionsData(@Body() req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            return this.storeConsumptionService.getAllStoreConsumptions(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(getAllStoreConsumptionsResponse, error);
        }
    }

    @Post('getStoreConsumptionItemsById')
    async getStoreConsumptionItemsById(@Body() getStoreConsumptionRequest: GetStoreConsumptionRequest): Promise<GetAllConsumptionItemsResponseModel> {
        try {
            return this.storeConsumptionService.getStoreConsumptionItemsById(getStoreConsumptionRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllConsumptionItemsResponseModel, error);
        }
    }

    //  @Post('getAllStoreConsumptionItemDetails')
    //  async getAllStoreConsumptionItemDetails(@Body() getStoreConsumptionRequest:GetStoreConsumptionRequest):Promise<GetAllConsumptionItemsResponseModel>{
    //      try{
    //          return this.storeConsumptionService.getAllStoreConsumptionItemDetails(getStoreConsumptionRequest);
    //      }catch(error){
    //          return this.applicationExceptionHandler.returnException(GetAllConsumptionItemsResponseModel, error);
    //      }
    //  } 

    /**
     * get Store Consumptions Data for id
     * @param storeConData 
     * @returns 
     */
    @Post('getStoreConsumptionDataForId')
    async getStoreConsumptionDataForId(@Body() req: GetStoreConsumptionRequest): Promise<GetStoreConsumptionResponse> {
        try {
            return await this.storeConsumptionService.getStoreConsumptionDataForId(req.storeConsumptionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetStoreConsumptionResponse, error);
        }
    }

    @Post('getConsumedItemsForSo')
    async getConsumedItemsForSo(@Body() req: ConsumedItemsForSoReq) {
        try {
            return await this.storeConsumptionService.getConsumedItemsForSo(req);
        } catch (error) {
            return error;
        }
    }

    @Post('getConsumedQty')
    async getConsumedQty(@Body() req: ConsumedQtyRequest) {
        try {
            return await this.storeConsumptionService.getConsumedQty(req);
        } catch (error) {
            return error;
        }
    }

    @Post('getConsumedNumbers')
    async getConsumedNumbers(@Body() req: ConsumedItemsForSoReq): Promise<IssuesDropDownResponse> {
        try {
            console.log(req);
            return await this.storeConsumptionService.getConsumedNumbers(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(IssuesDropDownResponse, error);
        }
    }


    @Post('getStoreConsumptionSOs')
    async getStoreConsumptionSOs(@Body() req: UnitIdRequest): Promise<GetStoreConsumptionSosResponseModel> {
        try {
            return await this.storeConsumptionService.getStoreConsumptionSOs(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetStoreConsumptionSosResponseModel, error);
        }
    }

    @Post('/getConsumedStockQty')
    async getConsumedStockQty(@Body() req: StockItemRequest): Promise<CommonResponse> {
        try {
            return await this.storeConsumptionService.getConsumedStockQty(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAvailableConsumedStockForSO')
    async getAvailableConsumedStockForSO(@Body() Req: ConsumtionReportRequest): Promise<StoreConsumptionReportResponse> {
        try {
            return await this.storeConsumptionService.getAvailableConsumedStockForSO(Req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(StoreConsumptionReportResponse, err);
        }
    }
    @Post('getSoDropForScReport')
    async getSoDropForScReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.storeConsumptionService.getSoDropForScReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('getItemDropForScReport')
    async getItemDropForScReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.storeConsumptionService.getItemDropForScReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * get All Cancelled SOs Store Consumptions Data
     * @param storeConData 
     * @returns 
     */
    @Post('getAllCancelledSosStoreConsumptions')
    async getAllCancelledSosStoreConsumptions(@Body() req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            return this.storeConsumptionService.getAllCancelledSosStoreConsumptions(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(getAllStoreConsumptionsResponse, error);
        }
    }

    /**
 * get All Cancelled SOs Store Consumptions Data
 * @param storeConData 
 * @returns 
 */
    @Post('getAllRevisedSosStoreConsumptions')
    async getAllRevisedSosStoreConsumptions(@Body() req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            return this.storeConsumptionService.getAllRevisedSosStoreConsumptions(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(getAllStoreConsumptionsResponse, error);
        }
    }
    @Post('getStoreConsumptionUsage')
    async getStoreConsumptionUsage():Promise<any>{
        try{
            return await this.storeConsumptionService.getStoreConsumptionUsage();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }

    }
    @Post('getIssuedQty')
    async getIssuedQty(@Body() req: ItemCodeRequest) {
        try{
            return await this.storeConsumptionService.getIssuedQty(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('createStoreIssues')
    async createStoreIssues(@Body() req:StoreIssuesRequest) {
        try{
            return await this.storeConsumptionService.createStoreIssues(req,false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    
    @Post('getPlaceListData')
    async getPlaceListData(@Body() dto:any) {
        try{
            return await this.storeConsumptionService.getPlaceListData(dto);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('updatePalletCodeInPlaceList')
    async updatePalletCodeInPlaceList(@Body() dto:PlaceListPalletDto):Promise<CommonResponse> {
        try{
            return await this.storeConsumptionService.updatePalletCodeInPlaceList(dto);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    
    @Post('placeListPrintData')
    async placeListPrintData(@Body() getStoreConsumptionRequest: GetStoreConsumptionRequest) :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.placeListPrintData(getStoreConsumptionRequest);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('updatePlaceListStatus')
    async updatePlaceListStatus(@Body() req: UpdatePlaceListStatus) :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.updatePlaceListStatus(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    
    @Post('updateReportedStock')
    async updateReportedStock(@Body() req: UpdatePlaceListStatus) :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.updateReportedStock(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

   
    
    @Post('getSosForIndentForm')
    async getSosForIndentForm() :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.getSosForIndentForm();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    
    @Post('getCountOfIndent')
    async getCountOfIndent() :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.getCountOfIndent();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    @Post('getEtdWiseData')
    async getEtdWiseData(@Body() req:saleOrderNoRequest) :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.getEtdWiseData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    @Post('getPoNumberForEtdGrid')
    async getPoNumberForEtdGrid() :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.getPoNumberForEtdGrid();
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    @Post('saveEtdWiseGridData')
    async saveEtdWiseGridData(@Body() dto:EtdWiseDto[]) :Promise<CommonResponse>{
        try{
            return await this.storeConsumptionService.saveEtdWiseGridData(dto);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

}
